import styled from 'styled-components'
import {colors} from '../../../themes/colors'

const {white, blue} = colors

export const FooterWrapper = styled.div`
  background: ${blue};
  color: ${white};
`